import { CustomFileMap } from '../../../types/FileManagerTypes';

// A location-scoped /filtered-files response may omit the scoped folder's
// ancestors. Back-fill missing chain nodes from the previous map so the
// breadcrumb (folderChain parentId walk) stays intact; nodes present in the
// response always win.
export const withPreservedFolderChain = (prev: CustomFileMap, next: CustomFileMap, rootFolderId: string, folderId?: string): CustomFileMap => {
  if (!folderId || folderId === rootFolderId) return next;

  const merged = { ...next };
  const seen = new Set<string>();
  let cursor: string | undefined = folderId;
  while (cursor && !seen.has(cursor)) {
    seen.add(cursor);
    if (!merged[cursor] && prev[cursor]) merged[cursor] = prev[cursor];
    cursor = (merged[cursor] ?? prev[cursor])?.parentId;
  }
  return merged;
};
